import React from 'react';
import { useFrame } from "@react-three/fiber"
import { heatDataNew } from "../../data/heatData"

function ShapeGroup({children}) {
  const ref = React.useRef(null)

  useFrame((state, delta) => {
    if (ref.current.position.x > -1 * heatDataNew.length * 2 ) {
      // console.log((ref.current.position.x - delta/4).toFixed(1))
      ref.current.position.x = ref.current.position.x - delta/4
    } else {
      ref.current.position.x = 0
    }
  })

  return (
    <group ref={ref}>
      {children}
    </group>
  )
}

export default ShapeGroup;